<template>
    <UILoader v-if="isDealerLoading || isUsersLoading" class="modalable" />

    <div v-else class="dealer-modal">
        <div class="dealer-modal__header">
            <div class="dealer-modal__name">
                {{ dealer?.name }}
            </div>

            <router-link
                v-if="dealer"
                :to="{ name: 'EditDealer', params: { dealer_id: dealer.id } }"
                class="dealer-modal__menu"
            >
                <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
            </router-link>
        </div>

        <div class="dealer-modal__section">
            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Марка</div>
                <div class="dealer-modal__item-value">
                    <div v-if="dealer?.is_hyundai_dealer">Hyundai</div>
                    <div v-if="dealer?.is_genesis_dealer">Genesis</div>
                </div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Код</div>
                <div class="dealer-modal__item-value">{{ dealer?.sap_code ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Холдинг</div>
                <div class="dealer-modal__item-value">{{ dealer?.holding_name ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Город</div>
                <div class="dealer-modal__item-value">{{ dealer?.city_name ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Сайт</div>
                <div class="dealer-modal__item-value">
                    <template v-if="dealer?.site">
                        <a
                            :href="dealer.site"
                            target="_blank"
                        >
                            {{ dealer.site }}

                            <img v-svg-inline src="@/assets/icons/arrowGoLink.svg" />
                        </a>
                    </template>
                    <template v-else>
                        -
                    </template>
                </div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Телефон</div>
                <div class="dealer-modal__item-value">{{ dealer?.phone ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Email</div>
                <div class="dealer-modal__item-value">{{ dealer?.email ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Сертифицированный дилер</div>
                <div class="dealer-modal__item-value">{{ dealer?.is_certified ? 'Да' : 'Нет' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Статус</div>
                <div class="dealer-modal__item-value">{{ dealer?.status ? getDealerStatusLabel(dealer.status) : '-' }}</div>
            </div>
        </div>

        <div class="dealer-modal__subtitle">Юридические данные</div>

        <div class="dealer-modal__section">
            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Название юр. лица</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.name ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">ИНН</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.inn ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">КПП</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.kpp ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">ОГРН</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.ogrn ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Должность подписанта</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.signer_position ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">ФИО подписанта</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.signer_fio ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Должность и ФИО подписанта (в РП)</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.signatory_position_and_name ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">На основании (в РП)</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.signer_basis ?? '-' }}</div>
            </div>

            <!--<div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Фактический адрес дилера</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.address ?? '-' }}</div>
            </div>-->

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Юридический адрес</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.address ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Номер договора</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.contract_number ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Дата договора</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.contract_date ?? '-' }}</div>
            </div>
        </div>

        <div class="dealer-modal__subtitle">Банковские реквизиты</div>

        <div class="dealer-modal__section">
            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Расчетный счет</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.bank_account ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Название банка</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.bank_name ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">Корр. Счет</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.correspondent_account ?? '-' }}</div>
            </div>

            <div class="dealer-modal__item">
                <div class="dealer-modal__item-title">БИК</div>
                <div class="dealer-modal__item-value">{{ dealer?.legal_entity?.bank_identification_code ?? '-' }}</div>
            </div>
        </div>

        <div class="dealer-modal__subtitle">Сотрудники</div>

        <div class="dealer-modal__table">
            <DataTable
                :headers="headers"
                :data="arUsers"
                has-actions
            >
                <template #actions="{ row }">
                    <a
                        :href="router.resolve({ name: 'EditUser', params: { user_id: row.id } }).href"
                        class="dealer-modal__table-menu"
                    >
                        <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
                    </a>
                </template>
            </DataTable>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { RouterKey } from '@/injection/keys.ts';

    import { Dealer, getDealerStatusLabel } from '@/types/dealer.type.ts';
    import { User } from '@/types/user.type.ts';

    import useDealerRepository from '@/repositories/dealer/useDealerRepository.ts';
    import useLoading from '@/utils/useLoading.ts';

    import { sortBy } from '@/utils/collection-helpers.ts';

    import DataTable from '@/components/shared/DataTable/DataTable.vue';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';

    const { dealerId } = defineProps<{
        dealerId: number,
    }>();

    const router = injectStrict(RouterKey);

    const { getDealer, getDealerUsers } = useDealerRepository();
    const { isLoading: isDealerLoading, setLoading: setDealerLoading } = useLoading();
    const { isLoading: isUsersLoading, setLoading: setUsersLoading } = useLoading();

    const dealer = ref<Dealer | null>(null);
    const arUsers = ref<User[]>([]);
    const headers = ref([
        { label: 'ФИО', key: 'full_name' },
        { label: 'Email', key: 'email' },
    ]);

    function fetchUsers(): void {
        setUsersLoading(true);

        getDealerUsers(dealerId)
            .then((users: User[]) => {
                arUsers.value = sortBy(users, 'full_name', 'asc');
                setUsersLoading(false);
            });
    }

    function fetchDealer(): void {
        setDealerLoading(true);

        getDealer(dealerId).then((fetchedDealer: Dealer) => {
            dealer.value = fetchedDealer;
            setDealerLoading(false);
        });

        fetchUsers();
    }

    onMounted(() => {
        fetchDealer();
    });
</script>

<style scoped lang="scss">
    @use 'DealerModal' as *;
</style>
